import React from "react";
import container from "../../../../styles/Global.module.css";
import { masterDesignStatus } from "../../../../json/StatusOptions.js";
import ColumnStatus from "../../../../components/global/fields/ColumnStatus.jsx";
import UsersSelect from "../../../../components/global/fields/UsersSelect.jsx";
import EditableText from "../../../../components/global/fields/EditableText.jsx";
import { getStatus } from "../../../../utils/ApiCall.js";
import BaseBoard from "../../../global/BoardTemplate/BaseBoard.jsx";
import SingleDuration from "../../../../components/global/fields/SingleDurationDatePicker.jsx";
import { useBoardStatePreset, useUsers } from "../../../../hooks/boards";
import { createStandardColumns } from "../../../../utils/boards";
import { separateTasksAlunaItems } from "../../../../utils/boards/boardFilters";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const AlunaMasterDesign = () => {
  let apiUrl = `${backendUrl}/api/master-design-aluna/items`;

  // Usar el hook refactorizado para el estado del board
  const [state, updateState] = useBoardStatePreset('master-design');
  
  // Usar el hook para cargar usuarios
  useUsers({
    onSuccess: (userData) => updateState({ users: userData })
  });

  const filterItemsAndSetGroups = (items) => {
    const separated = separateTasksAlunaItems(items);
    updateState({
      items: separated.open,
      itemsDone: separated.done,
    });
  };

  const handleEditResponseChange = async (newValue, rowID, field) => {
    let status;
    if (field !== "status") {
      status = await getStatus(rowID, `master-design-aluna`);
    } else {
      status = newValue;
    }

    if (status === "Done") {
      const updatedRowsTerminados = state.itemsDone.map((row) => {
        if (+row.id === +rowID) {
          return { ...row, [`${field}`]: newValue };
        }
        return row;
      });
      updateState({ itemsDone: updatedRowsTerminados });
    } else {
      const updatedRowsNoTerminados = state.items.map((row) => {
        if (+row.id === +rowID) {
          return { ...row, [`${field}`]: newValue };
        }
        return row;
      });
      updateState({ items: updatedRowsNoTerminados });
    }
  };

  const updateBoard = (newData) => {
    const updatedRows = [...state.updateRows, newData];
    updateState({ updateRows: updatedRows });
  };

  const getGroupRows = (groupName) => {
    return groupName === "Open" ? state.items : state.itemsDone;
  };

  // Usar el factory de columnas para eliminar duplicación
  const columnFactory = createStandardColumns();

  const columns = [
    columnFactory.id(),
    {
      field: "name",
      headerName: "Elemento",
      width: 300,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"name"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.name}
        />
      ),
    },
    columnFactory.threads(),
    {
      field: "owner.username",
      headerName: "Owner",
      width: 140,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row.owner?.username,
    },
    {
      field: "responsibles",
      headerName: "Responsable",
      width: 140,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <UsersSelect
          {...params}
          users={state.users}
          field={"responsibles"}
          handleEditResponseChange={handleEditResponseChange}
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",
      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"status"}
          columnPosition={280}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={masterDesignStatus}
        />
      ),
    },
    {
      field: "deadline",
      headerName: "Deadline",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <SingleDuration
          {...params}
          selectionRow={state.selectionRow}
          fieldKey="deadline"
        />
      ),
    },
  ];

  if (!apiUrl) {
    return <div className={container.globalContainer}>Cargando...</div>;
  }

  return (
    <div className={container.globalContainer}>
      <BaseBoard
        columns={columns}
        groups={state.groups}
        getGroupRows={getGroupRows}
        setGroupItems={filterItemsAndSetGroups}
        apiUrl={apiUrl}
        status={state.status}
        setStatus={(status) => updateState({ status })}
        updateBoard={updateBoard}
        refreshState={state.refreshState}
        updateRows={state.updateRows}
        setSelectionRow={(selectionRow) => updateState({ selectionRow })}
        selectionRow={state.selectionRow}
        viewFilter={state.viewFilter}
        setViewFilter={(viewFilter) => updateState({ viewFilter })}
        columnsFilter={state.columnsFilter}
        setColumnsFilter={(columnsFilter) => updateState({ columnsFilter })}
        pinnedColumns={state.pinnedColumns}
        setPinnedColumns={(pinnedColumns) => updateState({ pinnedColumns })}
        checkboxSelection={true}
        height={"80vh"}
        maxHeight={"80vh"}
      />
    </div>
  );
};

export default AlunaMasterDesign;
